import request from "@/api/Request";

let baseUrl = "/api/v1/endUser/booking_calendar";
let BookingCalendarApi = {
    get(facilityCode) {
        return request.get(baseUrl + "/get?facilityCode=" + facilityCode, {
            headers: {
                'Content-Type': undefined
            }
        })
    },
};

export default BookingCalendarApi;
